import { Outlet, createFileRoute } from "@tanstack/react-router";

import { RequireSession } from "@/components/RequireSession";
import { ResellerHeader } from "@/components/revendedor/ResellerHeader";
import { useSession } from "@/lib/session";
import { SiteFooter } from "@/components/SiteCredit";

/**
 * Moldura do painel do revendedor.
 *
 * O login é o mesmo do painel da equipe (`/admin/entrar`), que manda cada
 * papel para a sua área — um formulário só para manter.
 */
export const Route = createFileRoute("/revendedor/_area")({
  component: ResellerLayout,
});

function ResellerLayout() {
  return (
    <RequireSession roles={["REVENDEDOR"]} redirectTo="/admin/entrar">
      <ResellerArea />
    </RequireSession>
  );
}

function ResellerArea() {
  const { profile, logout } = useSession();
  return (
    <div className="flex min-h-screen flex-col bg-mb-surface">
      <ResellerHeader name={profile?.name ?? ""} onLogout={() => void logout()} />
      <main className="mx-auto w-full max-w-6xl grow px-4 py-8 sm:px-6">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
